export default __webpack_public_path__ + "static/media/purpleFlowers.23bcb28f.jpeg";